import { PageHero } from "../components/PageHero";
import { Reveal } from "../lib/motion";
import { INDUSTRIES, IMAGES } from "../lib/data";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Industries() {
  return (
    <>
      <PageHero
        testid="industries-hero"
        overline="Sectors & Geography"
        title="Nine sectors. Two geographies. One delivery discipline."
        subtitle="Every sector is led by a dedicated tech lead who has spent a career in it — from BFSI and healthcare to smart city, automotive and ed-tech."
      />
      <section className="bg-background py-24">
        <div className="container-x grid gap-5 md:grid-cols-2">
          {INDUSTRIES.map((ind, i) => {
            const Icon = ind.icon;
            return (
              <Reveal key={ind.name} delay={(i % 2) * 0.08}>
                <div
                  data-testid={`industry-${i}`}
                  className="group flex h-full items-start gap-6 rounded-2xl border border-border bg-background p-8 transition-all duration-300 hover:-translate-y-1 hover:border-accent/50 hover:shadow-[0_18px_50px_rgba(27,26,36,0.08)]"
                >
                  <span className="grid h-14 w-14 shrink-0 place-items-center rounded-xl bg-secondary text-navy transition-colors group-hover:bg-accent group-hover:text-white dark:text-white">
                    <Icon className="h-6 w-6" />
                  </span>
                  <div>
                    <h3 className="text-xl font-semibold tracking-tight">{ind.name}</h3>
                    <p className="mt-2 leading-relaxed text-muted-foreground">{ind.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="relative overflow-hidden border-y border-border">
        <img src={IMAGES.skyline} alt="Global markets" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-navy/80" />
        <div className="container-x relative py-24 text-white">
          <Reveal className="max-w-2xl">
            <p className="overline text-white/50">Geography</p>
            <h2 className="mt-4 text-balance text-3xl font-semibold tracking-tighter sm:text-4xl lg:text-5xl">
              Bengaluru delivery. Singapore partnership. Global reach.
            </h2>
            <p className="mt-6 text-lg font-light leading-relaxed text-white/70">
              A delivery hub in Bengaluru — the Silicon Valley of India — with a front-facing partner in Singapore.
              Priority target markets: KSA, US, UAE and Europe. Mid-market focus: $50M–$200M revenue, 50–200 employees.
            </p>
            <Link to="/contact" className="mt-8 inline-flex items-center gap-2 rounded-full bg-accent px-6 py-3 text-sm font-semibold transition-transform hover:scale-[1.03]">
              Talk to our team <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
